// extracted by mini-css-extract-plugin
export default {"container":"Home_container__w+u63","width":"Home_width__RXP53"};